import {atom, useAtom} from 'jotai';
import type {CommunicationsFilter} from '@api/meerec/types';

/** Состояние фильтров на странице звонков. */
export interface CallsFilterState {
  managerId?: string;
  isTargeted?: boolean;
  status?: CommunicationsFilter['status'];
  /** Тип коммуникации (`result.callType`, значения — из планов звонков). */
  callType?: string;
  search: string;
  /** MQL-путь поля, по которому ищем (contains). */
  searchField: string;
}

const initial: CallsFilterState = {
  search: '',
  isTargeted: true,
  searchField: 'communicationId',
};

/** Atom состояния фильтров (живёт между переходами между страницами). */
export const callsFilterAtom = atom<CallsFilterState>(initial);

/** Хук-обёртка для удобной работы с фильтрами. */
export const useCallsFilter = () => {
  const [filter, setFilter] = useAtom(callsFilterAtom);

  return {
    filter,
    setManagerId: (managerId?: string) => setFilter((p) => ({...p, managerId})),
    setIsTargeted: (isTargeted?: boolean) =>
      setFilter((p) => ({...p, isTargeted})),
    setStatus: (status?: CommunicationsFilter['status']) =>
      setFilter((p) => ({...p, status})),
    setCallType: (callType?: string) => setFilter((p) => ({...p, callType})),
    setSearch: (search: string) => setFilter((p) => ({...p, search})),
    setSearchField: (searchField: string) =>
      setFilter((p) => ({...p, searchField})),
    reset: () => setFilter(initial),
  };
};
